export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const FETCH_MESSAGES = 'FETCH_MESSAGES';
export const FETCH_NOTIFICATIONS_COUNT = 'FETCH_NOTIFICATIONS_COUNT';
export const FETCH_MESSAGES_COUNT = 'FETCH_MESSAGES_COUNT';
export const LOADING_NOTIFICATIONS = 'LOADING_NOTIFICATIONS';